document.addEventListener("DOMContentLoaded", function () {
    const header = document.getElementById("site-header");
    
    let lastScrollTop = 0;

    window.addEventListener("scroll", function () {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > 120) {
            header.classList.add("scrolled");
            header.firstElementChild.classList.remove("bordo");
        } else {
            header.classList.remove("scrolled");
            header.firstElementChild.classList.add("bordo");
        }

        // Nascondi navbar se si scrolla verso il basso
        if (currentScroll > 100 && currentScroll > lastScrollTop) {
            header.classList.add("-translate-y-full");
        } 
        // Mostra navbar se si scrolla verso l’alto
        else {
            header.classList.remove("-translate-y-full");
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Compatibilità Safari
    });
});





function tw_navwalker_dropdown(){
    const dropdownToggles = document.querySelectorAll('.dropdown > a[data-toggle="dropdown"]');

    dropdownToggles.forEach(toggle => {
        const parent = toggle.closest('.dropdown');
        const submenu = parent.querySelector('.dropdown-menu');

        if (!submenu) return;

        // Optional: Animate on hover for desktop
        parent.addEventListener('mouseenter', () => {
            submenu.classList.remove('hidden');
            submenu.classList.add('block', 'animate-fadeIn');
        });

        parent.addEventListener('mouseleave', () => {
            submenu.classList.remove('block', 'animate-fadeIn');
            submenu.classList.add('hidden');
        });

        // Click toggle for mobile
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            submenu.classList.toggle('hidden');
            submenu.classList.toggle('block');
            submenu.classList.add('transition-all', 'duration-300', 'ease-in-out');
        });
    });
}
document.addEventListener("DOMContentLoaded", tw_navwalker_dropdown);



// Language Switcher 
document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('languageDropdownToggle');
    const menu = document.getElementById('languageDropdownMenu');

    // Toggle dropdown visibility
    toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        const isHidden = menu.classList.contains('hidden');
        menu.classList.toggle('hidden', !isHidden);
        toggle.setAttribute('aria-expanded', isHidden.toString());
    });

    // Close dropdown on outside click
    document.addEventListener('click', function (e) {
        if (!menu.contains(e.target) && !toggle.contains(e.target)) {
            if (!menu.classList.contains('hidden')) {
                menu.classList.add('hidden');
                toggle.setAttribute('aria-expanded', 'false');
            }
        }
    });
});